module.exports = __webpack_public_path__ + "static/media/Img_15.0ba20df6.JPG";